<script>
  import { parseNumber, calcPercent, screenshot, makeWebsiteRequest } from '../../../Common/tools';
  import EmailBuilder from '../../Popups/EmailBuilder.svelte';
  import { getEmailBuilderFeatures, getAutomationSalesTotals, makeId, sendTestEmail, viewFullAnalytics } from '../../static';
  import { onMount } from 'svelte';
  import { External, M } from '../../../external';
  import { EMPTY_SALES_TOTALS, getSalesCountLabel } from '../../../Store/static';

  export let data;
  export let automation;
  export let stepId;
  export let automationSave;
  export let stepAdd;
  export let stepUpdate;
  export let order;
  export let valid;
  export let onChange;
  export let error;

  let subject = null;
  let name = null;
  let email = null;
  let replyEmail = null;
  let emailContent = null;
  let aligned = null;
  let defaultEmail = '';
  let thumb = '';
  let salesUtm = null;
  let salesTotals = EMPTY_SALES_TOTALS;

  const loadEmailContent = async (emailContentKey) => {
    if (emailContentKey && emailContentKey.startsWith('@')) {
      // emailContent contains just a link to the actual content. Retrieve it.
      let response = await makeWebsiteRequest({
        action: 'getAutomationEmailContent',
        data: {
          key: emailContentKey
        }
      });
      if (response && response.data) {
        return response.data;
      }
    }
    return emailContentKey;
  };

  const init = async () => {
    if (data && data.settings) {
      for (let idx = 0; idx < data.settings.length; ++idx) {
        let setting = data.settings[idx];
        switch (setting.key) {
          case 'aligned':
            aligned = setting.value;
            break;
          case 'subject':
            subject = setting.value;
            break;
          case 'name':
            name = setting.value;
            break;
          case 'email':
            email = setting.value;
            break;
          case 'replyEmail':
            replyEmail = setting.value;
            break;
          case 'emailContent':
            let actualEmailContent = await loadEmailContent(setting.value);
            emailContent = JSON.parse(actualEmailContent);
            break;
          case 'thumb':
            thumb = setting.value;
            break;
          case 'salesUtm':
            salesUtm = JSON.parse(setting.value);
            salesTotals = await getAutomationSalesTotals(automation, salesUtm);
            break;
          default:
            break;
        }
      }
      if (External.Website.emailMarketingSettings) {
        replyEmail = replyEmail || External.Website.emailMarketingSettings.replyEmail || '';
      }
      valid = subject && name && email && emailContent;
    } else if (External.Website.emailMarketingSettings) {
      defaultEmail = External.Website.emailMarketingSettings.defaultEmail || '';
      name = External.Website.emailMarketingSettings.defaultSender || '';
      replyEmail = External.Website.emailMarketingSettings.replyEmail || '';
      email = defaultEmail;
    }

    if (data && !data.id) {
      data.reservedId = makeId(10);
    }
  };

  const onValueChange = () => {
    data.settings = [];

    data.settings.push({
      key: 'aligned',
      value: aligned
    });

    data.settings.push({
      key: 'subject',
      value: subject
    });

    data.settings.push({
      key: 'name',
      value: name
    });

    data.settings.push({
      key: 'email',
      value: email
    });

    data.settings.push({
      key: 'replyEmail',
      value: replyEmail
    });

    data.settings.push({
      key: 'emailContent',
      value: JSON.stringify(emailContent)
    });

    data.settings.push({
      key: 'thumb',
      value: thumb
    });

    data.settings.push({
      key: 'salesUtm',
      value: JSON.stringify(salesUtm)
    });

    data.name = '"' + subject + '"';
    valid = subject && name && email && emailContent;

    if (valid && salesUtm) {
      valid = salesUtm.campaign?.length;
      if (!valid) {
        error = M.INVALID_UTM_CAMPAIGN;
      }
    }

    if (emailContent) {
      onChange();
    }
  };

  function onSend() {
    sendTestEmail(emailContent, defaultEmail);
  }

  const onEditEmail = async () => {
    let component;
    let emailContentChanged = false;

    External.Tools.showWindow({
      icon: External.Popup.ICON_EDIT,
      width: window.innerWidth * 0.9,
      customClass: 'automation-step-email-builder',
      isModal: false,
      withDarkBackground: true,
      noTitle: true,
      forceAtRight: true,// External.showBuilderPopupsOnFullHeight,
      markup: '<div class="full-size flex flex-col f-left bind-component"></div>',
      action: {
        onShow: function(popup, context) {
          component = new EmailBuilder({
            target: context.find('.bind-component')[0],
            props: {
              parentPopup: popup,
              data: {
                content: emailContent,
                subject: subject,
                name: name,
                email: email,
                replyEmail: replyEmail,
                automation: automation,
                stepId: stepId || data.reservedId
              },
              features: getEmailBuilderFeatures(automation),
              automationSave: (then) => {
                automationSave(() => {
                  emailContentChanged = false;
                  then();
                });
              },
              stepAdd: stepAdd,
              stepUpdate: stepUpdate,
              order: order,
              step: data,
              onContentChange: () => {
                emailContentChanged = true;
              },
              onSaveEmail: () => {
                emailContent = component.get().content;
                emailContentChanged = false;
                onValueChange();
                makeWebsiteRequest({
                  action: 'automationEmailContentChanged',
                  method: 'post',
                  data: {
                    content: JSON.stringify(emailContent),
                    fromName: name,
                    fromEmail: email
                  }
                });

                screenshot({
                  content: emailContent,
                  automationId: automation.id,
                  stepId: stepId || data.reservedId,
                  dimensions: emailContent.style.width,
                  onReady: (filename) => {
                    thumb = External.getThumbnailsFromBase(window.getUserDir(), 'emails', false) + filename + '.png?v=' + External.Tools.getTimestamp();
                    onValueChange();
                  }
                });

                popup.close();
              },
              onClose: () => {
                popup.close();
              }
            }
          });
        },
        onBeforeHide: function(popup, ui, closeAction) {
          if (emailContentChanged) {
            External.Tools.prompt(
              M.UNSAVED_CHANGES_TITLE,
              M.EMAIL_CHANGES_MADE,
              function() {
                emailContent = component.get().content;
                emailContentChanged = false;
                onValueChange();
                closeAction();
              },
              closeAction,
              M.SAVE_AND_CLOSE,
              M.UNSAVED_CHANGES_DISCARD_BTN,
              false,
              'unsaved-changes-dlg'
            );

            return false;
          }
        },
        onHide: function() {
          if (component) {
            component.$destroy();
            component = null;
          }
        }
      }
    });
  };

  let addProperty = () => {
    External.UITools.selectMarketingProperty(null, function(tag) {
      subject = (subject || '') + '{' + tag + '}';
    });
  };

  let enableSalesUtm = () => {
    salesUtm = salesUtm ? null : {};
    onValueChange();
  };

  onMount(async () => {
    await init();
    if (stepId && !thumb) {
      // old, for backwards compatibility only. Thumb URLs are now saved when the thumb is generated
      thumb = External.getThumbnailsFromBase(window.getUserDir(), 'emails', false) + automation.id + '_' + (stepId || data.reservedId) + '.png?v=' + External.Tools.getTimestamp();
    }
  });
</script>

<div class='col20 f-left small-rules mb-25'>
  <h4 class='col20 f-left mt-5 mb-25 t-center' style='line-height:1.4;'>{M.SEND_EMAIL}</h4>
  {#if data.id && data.sent > 0}
    <div class='chart-wrapper compact-chart-wrapper col20 f-left'>
      <div class='horizontal-chart-wrapper flex align-center'>
        <h4>{M.SENT}</h4>
        <div class='horizontal-chart-progress'>
          <div class='horizontal-chart-progress-inner' style='width:100%;'>
            <span class='chart-label'>{parseNumber(data.sent)} - 100%</span>
          </div>
        </div>
      </div>
      <div class='horizontal-chart-wrapper flex align-center'>
        <h4>{M.OPENED}</h4>
        <div class='horizontal-chart-progress'>
          <div class='horizontal-chart-progress-inner'
               style={"width:" + calcPercent(data.opened, data.sent) + "; background-color: #cac736"}>
            <span class='chart-label'>{parseNumber(data.opened)} - {calcPercent(data.opened, data.sent)}</span>
          </div>
        </div>
      </div>
      <div class='horizontal-chart-wrapper flex align-center'>
        <h4>{M.CLICKED}</h4>
        <div class='horizontal-chart-progress'>
          <div class='horizontal-chart-progress-inner'
               style={"width:" + calcPercent(data.clicked, data.sent) + "; background-color: #cac736"}>
            <span class='chart-label'>{parseNumber(data.clicked)} - {calcPercent(data.clicked, data.sent)}</span>
          </div>
        </div>
      </div>
      {#if salesUtm}
        <div class='horizontal-chart-wrapper flex align-center'>
          <h4>{M.PURCHASED}</h4>
          <div class='horizontal-chart-progress'>
            <div class='horizontal-chart-progress-inner'
                 style={"width:" + calcPercent(salesTotals.orders, data.sent) + "; background-color: #76bd65"}>
              <span class='chart-label'>{calcPercent(salesTotals.orders, data.sent)} - {External.Tools.currencyToStrWithSymbol(salesTotals.sales)}
                ({getSalesCountLabel(salesTotals.orders)})</span>
            </div>
          </div>
        </div>
      {/if}
    </div>
    <div class='col20 f-left mt-5 t-center'>
      <a class='middle-button blue f-none inline-block close-popup'
         on:click={() => viewFullAnalytics(automation.id)}>{M.VIEW_FULL_ANALYTICS}</a>
    </div>
  {/if}
  <div class='col20 f-left mt-25'>
    <div class='info'>
      <h5>{M.EMAIL_SUBJECT}</h5>
      <span class='light-gray-text'>{M.SUBJECT_DESC}</span>
    </div>
    <div class='popup-input-wrapper'>
      <div class='input-inner-wrapper input-wrapper-with-button'>
        <input
          type='text'
          name='emailSubject'
          bind:value={subject}
          on:change={onValueChange}
          class='modify transition-border'
          style='margin-bottom: 5px;'
          placeholder={M.ENTER_YOUR_SUBJECT_LINE} />
        <a class='middle-button light-gray-button circle-effect add-email-tags-btn'
           on:click={addProperty}>{M.ADD_PROPERTY}</a>
      </div>
    </div>
  </div>
  <div class='col20 f-left mt-10'>
    <div class='col20 f-left'>
      <div class='info'>
        <h5>{M.FROM_SENDER}</h5>
        <span class='light-gray-text'>{M.FROM_DESC}</span>
      </div>
      <input type='text' bind:value={name} on:change={onValueChange} class='modify transition-border half-input f-left'
             style='margin-bottom: 5px;' placeholder={M.SENDER_NAME} />
      <input type='text' bind:value={email} on:change={onValueChange}
             class='modify transition-border half-input f-right' style='margin-bottom: 5px;'
             placeholder={M.SENDER_EMAIL} />
    </div>
    <div class='col20 f-left mt-15'>
      <div class='info'>
        <h5>{M.REPLY_TO}</h5>
        <span class='light-gray-text'>{M.REPLY_TO_DESC}</span>
      </div>
      <input type='text' bind:value={replyEmail} on:change={onValueChange}
             class='modify transition-border half-input f-left' style='margin-bottom: 5px;'
             placeholder={M.REPLIES_RECEIVING_EMAIL} />
    </div>

    <div class='col20 f-left mt-20'>
      <div class="checkbox-wrapper">
        <input id="trackSalesCheck" class="css-checkbox select-cbx" checked={salesUtm}
               type="checkbox" name="trackSalesCheck" on:change={enableSalesUtm} />
        <label for="trackSalesCheck" class="css-label">{M.TRACK_EMAIL_SALES}</label>
      </div>
      {#if salesUtm}
        <div class="info">
          <span class="light-gray-text">{M.SALES_TRACKING_UTM_DESC}</span>
        </div>
        <div class="popup-input-wrapper mt-15 mb-5">
          <span class="recipients-total f-16 f-left mr-5" style="display: inline">{M.SOURCE}</span>
          <span class="light-gray-text" style="line-height: 1.4">{M.FB_GOOGLE_NEWSLETTER}</span>
          <input type="text" placeholder={M.SOURCE} bind:value={salesUtm.source} on:change={onValueChange} class="col20 f-left clear-left"
                 style="margin-top: 5px" />
        </div>
        <div class="popup-input-wrapper mb-5">
          <span class="recipients-total f-16 f-left mr-5" style="display: inline">{M.CAMPAIGN}</span>
          <span class="light-gray-text" style="line-height: 1.4">{M.DEAL_PROMOTION}</span>
          <input type="text" placeholder={M.CAMPAIGN} bind:value={salesUtm.campaign} on:change={onValueChange} class="col20 f-left clear-left"
                 style="margin-top: 5px" />
        </div>
        <div class="popup-input-wrapper">
          <span class="recipients-total f-16 f-left mr-5" style="display: inline">{M.UTM_MEDIUM}</span>
          <span class="light-gray-text" style="line-height: 1.4">{M.SOCIAL_PPC_EMAIL}</span>
          <input type="text" placeholder={M.UTM_MEDIUM} bind:value={salesUtm.medium} on:change={onValueChange} class="col20 f-left clear-left"
                 style="margin-top: 5px" />
        </div>
      {/if}
    </div>

    {#if !emailContent}
      <div class='col20 f-left mt-15 t-center'>
        <a on:click={onEditEmail} class='big-button blue f-none inline-block'>{M.START_BUILDING_EMAIL}</a>
      </div>
    {:else}
      <div class='recipients-summary f-left col20 mt-15 mb-35 gray-section flex align-center'>
        {#if thumb}
          <img alt='' class='system-email-box-img' src={External.content + thumb} style='margin-right: 15px;' />
        {/if}
        <div class='t-center'>
          <a on:click={onSend}
             class='middle-button f-none inline-block light-gray-button mr-5 mb-5 rounded-effect'> {M.SEND_TEST_EMAIL} </a>
          <a on:click={onEditEmail} class='middle-button blue f-none inline-block rounded-effect'> {M.EDIT_EMAIL} </a>
        </div>
      </div>
    {/if}
  </div>
</div>
